export default "__VITE_PUBLIC_ASSET__2ffcd1b7__"